import {InputBase, Divider as MuiDivider, Button} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {Form} from "../../component"

export const DefaultForm = styled(Form)`
    @media (min-width: ${breakpoints.values.md}px) {
        width: 17.875rem;
    }
`

export const InputContainer = styled(InputBase)`
    width: 100%;
    letter-spacing: normal;

    input:disabled {
        background-color: #f7f7f7;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.textField.medium.borderRadius};
    }
    input {
        padding: 0rem 3.5rem 0rem 1rem;
        padding-left: ${({theme}) =>
            parseFloat(theme.uxfabric.shape.global.textField.medium.borderRadius) >= 4 ? "1rem" : "0.75rem"};
        color: ${({theme}) => theme.uxfabric.text.primary};
        font-size: inherit;
        border: none !important;
        box-sizing: content-box !important;

        &::-ms-clear {
            display: none;
        }

        ::placeholder {
            color: ${({theme}) => theme.uxfabric.text.primary};
            opacity: inherit;
            background: ${({theme}) => theme.uxfabric.action.default.enabled.backgroundColor};
            text-transform: ${({theme}) => theme.uxfabric.component.inputText.textTransform};
        }

        @media (max-width: ${breakpoints.values.md - 1}px) {
            font-size: 1rem;
        }
    }
`
export const Divider = styled(MuiDivider)`
    && {
        border-right: 0.0625rem solid;
        border-color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.borderColor};
        border-radius: ${({theme}) => theme.uxfabric.shape.global.textField.medium.borderRadius};
        height: auto;
    }
`
export const SubmitButton = styled(Button)`
    && {
        width: 2.75rem;
        min-width: 2.75rem;
        height: 2.75rem;
        min-height: 2.75rem;

        background: ${({theme}) => theme.uxfabric.action.default.enabled.backgroundColor};
        padding: 0;
        border: inherit;
        transition: none;

        @media (min-width: ${breakpoints.values.md}px) {
            width: 2.25rem;
            min-width: 2.25rem;
            height: 2.25rem;
            min-height: 2.25rem;
        }

        &:hover,
        &:active {
            background: ${({theme}) => theme.uxfabric.action.default.enabled.backgroundColor};
            border: 0;
        }
    }
`

export const ClearButton = styled("a")`
    width: 2.75rem;
    min-width: 2.75rem;
    height: 2.75rem;
    min-height: 2.75rem;
    right: 2.75rem;

    position: absolute;
    color: ${({theme}) => theme.uxfabric.text.primary};
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: ${breakpoints.values.md}px) {
        width: 2.25rem;
        min-width: 2.25rem;
        height: 2.25rem;
        min-height: 2.25rem;
        right: 2.313rem;
    }
`
